import { RootState } from ".";

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { getLinkedinAdAccounts } from "../api/integration";
import { LinkedinAdAccount } from "../types/linkedin";

export interface LinkedinState {
  isLoadingAdAccounts: boolean;
  adAccounts: LinkedinAdAccount[];
}

export const loadLinkedinAdAccounts = createAsyncThunk<
  LinkedinAdAccount[],
  void,
  { state: RootState }
>("linkedin/loadAdAccounts", async (_, { getState }) => {
  const {
    workspace: { slug },
  } = getState();
  return await getLinkedinAdAccounts(slug);
});

export const selectLinkedin = (state: RootState) => state.linkedin;

export const selectLinkedinAdAccounts = createSelector(
  [selectLinkedin],
  (linkedin) => linkedin.adAccounts,
);

export const selectLinkedinAdAccountById = (id: number) =>
  createSelector([selectLinkedinAdAccounts], (adAccounts) =>
    adAccounts.find((account) => account.id === id),
  );

export const linkedinSlice = createSlice({
  name: "linkedin",
  initialState: {
    isLoadingAdAccounts: false,
    adAccounts: [],
  } as LinkedinState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadLinkedinAdAccounts.pending, (state) => {
      state.isLoadingAdAccounts = true;
    });
    builder.addCase(loadLinkedinAdAccounts.fulfilled, (state, action) => {
      state.isLoadingAdAccounts = false;
      state.adAccounts = action.payload;
    });
    builder.addCase(loadLinkedinAdAccounts.rejected, (state) => {
      state.isLoadingAdAccounts = false;
    });
  },
});

export default linkedinSlice.reducer;
